var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "view-contanier" },
    [
      _c("div", { staticClass: "setting-box" }, [
        _c("div", { staticClass: "setting-header" }, [
          _c("div", [
            _c("div", [_vm._v("邮件供应商")]),
            Object.keys(_vm.currentService).length > 0
              ? _c("div", [
                  _c("img", {
                    attrs: {
                      src: _vm.currentService.logoPath,
                      alt: _vm.currentService.serviceName,
                    },
                  }),
                ])
              : _c("div", [_vm._v(" -- ")]),
          ]),
          _c("div", [
            _c("div", [_vm._v("邮箱账号")]),
            Object.keys(_vm.currentService).length > 0
              ? _c("div", [
                  _c("i", { staticClass: "el-icon-message" }),
                  _vm._v(" " + _vm._s(_vm.currentService.email) + " "),
                ])
              : _c("div", [_vm._v(" -- ")]),
          ]),
          _c(
            "div",
            [
              _c(
                "el-popover",
                { attrs: { placement: "bottom", trigger: "click" } },
                [
                  _c(
                    "div",
                    { staticClass: "account-list" },
                    [
                      _vm._l(_vm.emailServiceList, function (item) {
                        return _c(
                          "div",
                          {
                            key: item.id,
                            staticClass: "account-item",
                            on: {
                              click: function ($event) {
                                return _vm.changeAcount(item)
                              },
                            },
                          },
                          [
                            _c("div", [_vm._v(_vm._s(item.email))]),
                            item.isActived
                              ? _c("div", { staticClass: "curr-account" }, [
                                  _vm._v("当前"),
                                ])
                              : _vm._e(),
                          ]
                        )
                      }),
                      _c(
                        "div",
                        {
                          staticClass: "add-account",
                          on: {
                            click: function ($event) {
                              _vm.dialogVisible = true
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-circle-plus-outline",
                          }),
                          _vm._v(" 添加账户 "),
                        ]
                      ),
                    ],
                    2
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { slot: "reference", size: "small" },
                      slot: "reference",
                    },
                    [
                      _c("i", { staticClass: "el-icon-s-operation" }),
                      _vm._v(" 更换邮箱 "),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _c("div", { staticClass: "email-floder" }, [
        _c("div", { staticClass: "email-floder-tab" }, [
          _c(
            "div",
            {
              class: _vm.folderTab === 0 ? "tab-actived" : "",
              on: {
                click: function ($event) {
                  _vm.folderTab = 0
                },
              },
            },
            [_vm._v("文件管理")]
          ),
          _c(
            "div",
            {
              class: _vm.folderTab === 1 ? "tab-actived" : "",
              on: {
                click: function ($event) {
                  _vm.folderTab = 1
                },
              },
            },
            [_vm._v("签名设置")]
          ),
        ]),
        _vm.folderTab === 0
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                staticClass: "email-floder-section",
              },
              [
                _vm._l(_vm.currentService.folderList, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "folder-item",
                      on: {
                        contextmenu: function ($event) {
                          $event.preventDefault()
                          return _vm.onContextMenu($event, item)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        [
                          _c("svg-icon", {
                            attrs: { className: "folder", iconClass: "folder" },
                          }),
                        ],
                        1
                      ),
                      !_vm.menu.isReName
                        ? _c("div", [_vm._v(_vm._s(item.folderName))])
                        : _vm._e(),
                      _vm.menu.isReName
                        ? _c("div", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: item.folderName,
                                  expression: "item.folderName",
                                },
                              ],
                              staticStyle: {
                                width: "100%",
                                border: "1px solid #f1f1f1",
                              },
                              domProps: { value: item.folderName },
                              on: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  )
                                    return null
                                  return _vm.folderReName.apply(null, arguments)
                                },
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    item,
                                    "folderName",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ])
                        : _vm._e(),
                    ]
                  )
                }),
                _c(
                  "ul",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.menu.visible,
                        expression: "menu.visible",
                      },
                    ],
                    staticClass: "context-menu",
                    style: {
                      left: _vm.menu.x + "px",
                      top: _vm.menu.y + "px",
                    },
                    on: { click: _vm.hideMenu },
                  },
                  [
                    _c(
                      "li",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.handle("delete")
                          },
                        },
                      },
                      [_vm._v("删除文件夹")]
                    ),
                    _c(
                      "li",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.handle("rename")
                          },
                        },
                      },
                      [_vm._v("重命名")]
                    ),
                    _c(
                      "li",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.handle("view")
                          },
                        },
                      },
                      [_vm._v("查看")]
                    ),
                    _c(
                      "li",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.handle("update")
                          },
                        },
                      },
                      [_vm._v("修改文件夹")]
                    ),
                    _c(
                      "li",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.handle("add")
                          },
                        },
                      },
                      [_vm._v("新增文件夹")]
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.menu.detailVisible,
                        expression: "menu.detailVisible",
                      },
                    ],
                    staticClass: "folder-view",
                    style: {
                      left: _vm.menu.x + "px",
                      top: _vm.menu.y + "px",
                    },
                  },
                  [
                    _c("el-button", {
                      staticClass: "close",
                      attrs: {
                        icon: "el-icon-close",
                        size: "small",
                        circle: "",
                      },
                      on: { click: _vm.hideDetailMenu },
                    }),
                    _c("div", { staticClass: "folder-view-header" }, [
                      _c(
                        "div",
                        { staticClass: "folder-view-header-left" },
                        [
                          _c("svg-icon", {
                            attrs: { className: "folder", iconClass: "folder" },
                          }),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "folder-view-header-right" }, [
                        _c("div", [
                          _vm._v(_vm._s(_vm.currentFolder.folderName)),
                        ]),
                        _c("div", [
                          _c("div", [
                            _c("span", [_vm._v("创建时间：")]),
                            _vm._v(_vm._s(_vm.currentFolder.createdOn)),
                          ]),
                          _c("div", [
                            _c("span", [_vm._v("邮件数量：")]),
                            _vm._v(_vm._s(_vm.currentFolder.emailCount)),
                          ]),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "folder-view-section" }, [
                      _c("div", [
                        _vm._v(_vm._s(_vm.currentFolder.folderRuleTypeName)),
                      ]),
                      _c(
                        "div",
                        _vm._l(
                          _vm.currentFolder.ruleList,
                          function (item, index) {
                            return _c("div", { key: index }, [
                              _vm._v(_vm._s(item.ruleName)),
                            ])
                          }
                        ),
                        0
                      ),
                    ]),
                  ],
                  1
                ),
                !this.currentService.folderList ||
                this.currentService.folderList.length === 0
                  ? _c(
                      "el-empty",
                      {
                        staticStyle: { width: "100%" },
                        attrs: { description: "暂无文件夹" },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: {
                              background: "#5753e8",
                              "border-color": "#5753e8",
                            },
                            attrs: { type: "primary", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handle("add")
                              },
                            },
                          },
                          [_vm._v("立即创建")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              2
            )
          : _c(
              "div",
              { staticClass: "email-floder-section email-flode-signature" },
              [
                _c(
                  "div",
                  [
                    _c("vue-editor", {
                      ref: "editor",
                      staticClass: "email-editor",
                      attrs: { "editor-toolbar": _vm.customToolbar },
                      on: { ready: _vm.onEditorReady },
                      model: {
                        value: _vm.signature.content,
                        callback: function ($$v) {
                          _vm.$set(_vm.signature, "content", $$v)
                        },
                        expression: "signature.content",
                      },
                    }),
                  ],
                  1
                ),
                _c("div", [
                  _c(
                    "div",
                    [
                      _c("el-switch", {
                        attrs: { "active-text": "启用签名" },
                        model: {
                          value: _vm.signature.isActived,
                          callback: function ($$v) {
                            _vm.$set(_vm.signature, "isActived", $$v)
                          },
                          expression: "signature.isActived",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "send",
                          staticStyle: {
                            "border-color": "#1258bc",
                            background: "#1258bc",
                          },
                          attrs: {
                            size: "small",
                            type: "primary",
                            loading: _vm.signatureLoading,
                          },
                          on: { click: _vm.saveSignature },
                        },
                        [_vm._v("保存")]
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            ),
      ]),
      _c("addAccountDialogVue", {
        attrs: { dialogVisible: _vm.dialogVisible },
        on: { cancel: _vm.cancel },
      }),
      _c("addFolderDialog", {
        attrs: {
          dialogVisible: _vm.folderDialogVisible,
          currentFolder: _vm.currentFolder,
        },
        on: { cancel: _vm.folderCancel },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }